import PropTypes from "prop-types";
import { Network, X } from "lucide-react";
import chatbot from "../../../../assets/chatbot.png";
import FalconAIChatbot from "./FalconAIChatbot";
import DataLineageViewers from "../DataLineage/objectOrientedDataLineage";
import TransformationRuleLLMPopup from "./TransformationRulePopup";
import { toast } from "react-toastify";

const SidePanels = ({
  showAIAgent,
  setShowAIAgent,
  showReverseEngineering,
  setShowReverseEngineering,
  panelWidth,
  setPanelWidth,
  isResizingPanel,
  setIsResizingPanel,
  containerRef,
  panelRef,
  resizerRef,
  pageData,
  activeTab,
  setActiveTab,
  selectedTargetStructure,
  setSelectedTargetStructure,
  dropdownValue,

}) => {
  return (
    <>
      {/* AI Agent Panel */}
      <div
        ref={panelRef}
        style={{
          width: showAIAgent ? `${panelWidth}px` : "0px",
          minWidth: showAIAgent ? `${panelWidth}px` : "0px",
          maxWidth: showAIAgent ? `${panelWidth}px` : "0px",
          height: "calc(100vh - 180px)",
          overflow: "hidden",
          transition: showAIAgent
            ? "none"
            : "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderLeft: showAIAgent ? "1px solid #e0e0e0" : "none",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow: showAIAgent ? "-2px 0 8px rgba(0,0,0,0.1)" : "none",
          zIndex: 1000,
          flexShrink: 0,
          position: "relative",
        }}
      >
        {/* Resizer Handle - Left edge of panel */}
        {showAIAgent && (
          <button
            type="button"
            ref={resizerRef}
            aria-label="Resize panel"
            onMouseDown={() => setIsResizingPanel(true)}
            onKeyDown={(e) => {
              if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                e.preventDefault();
                const containerWidth =
                  containerRef.current?.getBoundingClientRect().width || 800;
                const maxWidth = Math.floor(containerWidth * 0.7);
                const newWidth =
                  e.key === "ArrowLeft"
                    ? Math.max(300, panelWidth - 10)
                    : Math.min(maxWidth, panelWidth + 10);
                setPanelWidth(newWidth);
              }
            }}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "8px",
              height: "100%",
              cursor: "col-resize",
              backgroundColor: "transparent",
              transition: "background-color 0.2s",
              zIndex: 1001,
              userSelect: "none",
              touchAction: "none",
              border: "none",
              padding: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onFocus={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onMouseLeave={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            onBlur={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            title="Drag to resize panel"
          />
        )}

        {showAIAgent && (
          <>
            {/* Header with Tabs */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                flexShrink: 0,
                paddingLeft: "20px",
              }}
            >
              {/* Title Row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  height: "52px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={chatbot}
                      alt="Falcon AI Logo"
                      className="w-6 h-6 rounded-full object-cover cursor-pointer"
                    />
                  </div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    BlueGecko AI
                  </h3>
                </div>
                <button
                  onClick={() => {
                    setShowAIAgent(false);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                    transition: "background-color 0.2s",
                    color: "#666",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e8e8e8")
                  }
                  onFocus={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e8e8e8")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                  onBlur={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                  title="Close BlueGecko AI"
                >
                  <X size={18} />
                </button>
              </div>

              {/* Tab Buttons */}
              <div
                style={{
                  display: "flex",
                  gap: "0px",
                  paddingLeft: "16px",
                }}
              >
                <button
                  onClick={() => setActiveTab('mapping')}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: activeTab === 'mapping' ? "#fff" : "transparent",
                    border: "none",
                    borderBottom: activeTab === 'mapping' ? "2px solid #2196f3" : "2px solid transparent",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: activeTab === 'mapping' ? 600 : 400,
                    color: activeTab === 'mapping' ? "#2196f3" : "#666",
                    transition: "all 0.2s",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                  }}
                  onMouseOver={(e) => {
                    if (activeTab !== 'mapping') {
                      e.currentTarget.style.backgroundColor = "#f0f0f0";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (activeTab !== 'mapping') {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  Mapping
                </button>
                <button
                  onClick={() => {
                    setActiveTab('transformation');
                    const targetFromDropdown = dropdownValue?.label;
                    setSelectedTargetStructure(targetFromDropdown);
                  }}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: activeTab === 'transformation' ? "#fff" : "transparent",
                    border: "none",
                    borderBottom: activeTab === 'transformation' ? "2px solid #2196f3" : "2px solid transparent",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: activeTab === 'transformation' ? 600 : 400,
                    color: activeTab === 'transformation' ? "#2196f3" : "#666",
                    transition: "all 0.2s",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                  }}
                  onMouseOver={(e) => {
                    if (activeTab !== 'transformation') {
                      e.currentTarget.style.backgroundColor = "#f0f0f0";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (activeTab !== 'transformation') {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  Transformation Rule
                </button>
              </div>
            </div>

            {/* Tab Content */}
            <div
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                paddingLeft: "8px",
                backgroundColor: "#fff",
              }}
            >
              {activeTab === 'mapping' ? (
                <FalconAIChatbot fileId={pageData.fileID} />
              ) : (
                <TransformationRuleLLMPopup
                  onClose={() => setActiveTab('mapping')}
                  targetStructure={selectedTargetStructure}
                  mappingFileId={pageData.fileID}
                  onApplyRule={(rule) => {
                    console.log("Generated rule to apply:", rule);
                    toast.success("Rule generated! Click on transformation cells to apply.");
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>


      {/* Reverse Engineering Panel */}
      <div
        style={{
          width: showReverseEngineering ? `${panelWidth}px` : "0px",
          minWidth: showReverseEngineering ? `${panelWidth}px` : "0px",
          maxWidth: showReverseEngineering ? `${panelWidth}px` : "0px",
          height: "calc(100vh - 180px)",
          overflow: "hidden",
          transition: showReverseEngineering
            ? "none"
            : "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderLeft: showReverseEngineering ? "1px solid #e0e0e0" : "none",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow: showReverseEngineering
            ? "-2px 0 8px rgba(0,0,0,0.1)"
            : "none",
          zIndex: 1000,
          flexShrink: 0,
          position: "relative",
        }}
      >
        {/* Resizer Handle */}
        {showReverseEngineering && (
          <button
            type="button"
            aria-label="Resize panel"
            onMouseDown={() => setIsResizingPanel(true)}
            onKeyDown={(e) => {
              if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                e.preventDefault();
                const containerWidth =
                  containerRef.current?.getBoundingClientRect().width || 800;
                const maxWidth = Math.floor(containerWidth * 0.7);
                const newWidth =
                  e.key === "ArrowLeft"
                    ? Math.max(300, panelWidth - 10)
                    : Math.min(maxWidth, panelWidth + 10);
                setPanelWidth(newWidth);
              }
            }}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "8px",
              height: "100%",
              cursor: "col-resize",
              backgroundColor: "transparent",
              transition: "background-color 0.2s",
              zIndex: 1001,
              userSelect: "none",
              touchAction: "none",
              border: "none",
              padding: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onFocus={(e) => {
              e.currentTarget.style.backgroundColor = "#2196f3";
            }}
            onMouseLeave={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            onBlur={(e) => {
              if (!isResizingPanel) {
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
            title="Drag to resize panel"
          />
        )}

        {showReverseEngineering && (
          <>
            {/* ERD Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                flexShrink: 0,
                height: "52px",
                paddingLeft: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Network size={20} color="#2196f3" />
                <h3
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  Mapping Graph
                </h3>
              </div>
              <button
                onClick={() => {
                  setShowReverseEngineering(false);
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  transition: "background-color 0.2s",
                  color: "#666",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8e8e8")
                }
                onFocus={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e8e8e8")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                onBlur={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                title="Close ERD"
              >
                <X size={18} />
              </button>
            </div>

            {/* ERD Content */}
            <div
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                paddingLeft: "8px",
              }}
            >
              <DataLineageViewers />
            </div>
          </>
        )}
      </div>
    </>
  );
};

SidePanels.propTypes = {
  showAIAgent: PropTypes.bool.isRequired,
  setShowAIAgent: PropTypes.func.isRequired,
  showReverseEngineering: PropTypes.bool.isRequired,
  setShowReverseEngineering: PropTypes.func.isRequired,
  panelWidth: PropTypes.number.isRequired,
  setPanelWidth: PropTypes.func.isRequired,
  isResizingPanel: PropTypes.bool.isRequired,
  setIsResizingPanel: PropTypes.func.isRequired,
  containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  panelRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  resizerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  pageData: PropTypes.shape({
    fileID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  selectedTargetStructure: PropTypes.string,
  setSelectedTargetStructure: PropTypes.func,
  dropdownValue: PropTypes.object,
};

export default SidePanels;